module.exports = __webpack_public_path__ + "media/images/admin/icons/share-50a1309b7798d80f7d2e288c9fc6364d.svg";